goog.provide("shadow.js.shim.module$src$svg$inform$check_circle_fill_svg$default");
shadow.js.shim.module$src$svg$inform$check_circle_fill_svg$default = shadow.js.shim.module$src$svg$inform$check_circle_fill_svg.default;
